// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.savedContentContainer {
  background-color: var(--background);
  height: 100vh;
  overflow: hidden;
  flex-direction: column;
  overflow: auto;
  padding-top: 2rem;
}

.savedHeader {
  padding: 16px;
  text-align: center;
  color: var(--text-primary);
  position: sticky;
  top: 10px;
  background-color: var(--background);
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.loader-container {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.saved-card-container {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 16px 72px 16px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 20px;
  background-color: var(--background);
}

.saved-content-card {
  position: relative;
  aspect-ratio: 2/3;  /* This replaces padding-top for better poster ratio */
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.6);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.saved-content-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.saved-content-card img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.saved-content-card h2 {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 12px;
  margin: 0;
  background: linear-gradient(to top, #ff7c62cc, #ff7c6200);
  background-size: 100% 100%;
  color: #fff;
  font-size: 14px;
  line-height: 1.2;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 4.5);
  background-color: rgba(0, 0, 0, 0.1);
}

.saved-delete-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(var(--theme-consistent-rgb), 0.8);
  color: var(--theme-consistent);
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;
}

.no-content-message {
  text-align: center;
  padding: 2rem;
  color: var(--text-primary);
  font-size: 1.1rem;
  margin-top: 2rem;
}

.saved-delete-icon:hover {
  background-color: rgba(var(--theme-consistent-rgb), 1);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}

.saved-delete-icon:active {
  transform: scale(0.95);
}

@media (max-width: 768px) {
  .savedContentContainer {
    height: calc(100vh - 80px);
  }

  .savedHeader {
    font-size: 20px;
    padding: 12px;
  }

  .saved-card-container {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 12px;
    padding: 12px 12px 32px 12px;
    margin-bottom: 100px;
  }

  .saved-content-card h2 {
    font-size: 16px;
    padding: 8px;
  }

  .saved-content-card {
    aspect-ratio: 2/3;
    width: 100%;
    height: auto;
  }

  .saved-delete-icon {
    padding: 6px;
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/SavedContent.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,SAAS;EACT,mCAAmC;EACnC,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB,GAAG,sDAAsD;EAC1E,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,SAAS;EACT,yDAAyD;EACzD,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wDAAwD;EACxD,8BAA8B;EAC9B,oCAAoC;EACpC,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;EACtD,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,4DAA4D;IAC5D,SAAS;IACT,4BAA4B;IAC5B,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".savedContentContainer {\n  background-color: var(--background);\n  height: 100vh;\n  overflow: hidden;\n  flex-direction: column;\n  overflow: auto;\n  padding-top: 2rem;\n}\n\n.savedHeader {\n  padding: 16px;\n  text-align: center;\n  color: var(--text-primary);\n  position: sticky;\n  top: 10px;\n  background-color: var(--background);\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.loader-container {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.saved-card-container {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 16px 72px 16px;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));\n  gap: 20px;\n  background-color: var(--background);\n}\n\n.saved-content-card {\n  position: relative;\n  aspect-ratio: 2/3;  /* This replaces padding-top for better poster ratio */\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.6);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.saved-content-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.saved-content-card img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.saved-content-card h2 {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 12px;\n  margin: 0;\n  background: linear-gradient(to top, #ff7c62cc, #ff7c6200);\n  background-size: 100% 100%;\n  color: #fff;\n  font-size: 14px;\n  line-height: 1.2;\n  font-weight: 600;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 4.5);\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.saved-delete-icon {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(var(--theme-consistent-rgb), 0.8);\n  color: var(--theme-consistent);\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 12px;\n}\n\n.no-content-message {\n  text-align: center;\n  padding: 2rem;\n  color: var(--text-primary);\n  font-size: 1.1rem;\n  margin-top: 2rem;\n}\n\n.saved-delete-icon:hover {\n  background-color: rgba(var(--theme-consistent-rgb), 1);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n}\n\n.saved-delete-icon:active {\n  transform: scale(0.95);\n}\n\n@media (max-width: 768px) {\n  .savedContentContainer {\n    height: calc(100vh - 80px);\n  }\n\n  .savedHeader {\n    font-size: 20px;\n    padding: 12px;\n  }\n\n  .saved-card-container {\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n    gap: 12px;\n    padding: 12px 12px 32px 12px;\n    margin-bottom: 100px;\n  }\n\n  .saved-content-card h2 {\n    font-size: 16px;\n    padding: 8px;\n  }\n\n  .saved-content-card {\n    aspect-ratio: 2/3;\n    width: 100%;\n    height: auto;\n  }\n\n  .saved-delete-icon {\n    padding: 6px;\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
